import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  const location = useLocation();
  const isRegisterPage = location.pathname.includes('/register');

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo */}
        <div className="flex justify-center">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary flex items-center justify-center">
              <span className="text-white font-bold text-xl">A</span>
            </div>
            <span className="text-2xl font-bold text-primary">Alkina Realty</span>
          </Link>
        </div>
        
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Welcome to Alkina Realty
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Premium real estate services with expert agents
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
        
        {/* Footer links */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            {isRegisterPage ? (
              <>
                Already have an account?{' '}
                <Link to="/auth/login" className="font-medium text-primary hover:text-primary-light">
                  Sign in
                </Link>
              </>
            ) : (
              <>
                Don't have an account?{' '}
                <Link to="/auth/register" className="font-medium text-primary hover:text-primary-light">
                  Sign up
                </Link>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;

